export default __webpack_public_path__ + "static/media/sd-trash.bb8494aa.svg";